//one-card-activeproblem/card.tsx
//Import Dependencies
import * as React from 'react';
import Table from "antd/lib/table";

import {
  Card
} from 'one-ui-card/src/card';

import {
  AlertsCardProps
} from './props';

import {
  AlertsModal
} from './model';

import {
  checkCardHasError,
  TriageCardErrorMsg
} from 'one-card-notification';



/**
 *  card renders all patient related active problemsdata
 * @param props component properties
 * @returns JSX code for Active Problems
 */
export const AlertsCard = <M extends AlertsModal>(
  props: AlertsCardProps<M>
) => {
  const {
    model,
    title,
  } = props;

  const {
    alerts
  } = model || {};

  let activeproblemsUI;

  console.log("-----Alerts",alerts)


  //Table Columns

  let columns = [
    {
      title: "Alerts",
      dataIndex: "alerts",
      key: "alerts"
    },
    {
      title: "Alerts Description",
      dataIndex: "alertdescription",
      key: "alertdescription"
    }
  ];

  if (checkCardHasError("Alerts") && alerts.length === 0) {
    activeproblemsUI =
      <>
        <TriageCardErrorMsg />
      </>
  }
  else {
    activeproblemsUI =
      <>
       <Table columns={columns} dataSource={alerts}
          size={'small'}
          pagination={{ defaultPageSize: 3, showSizeChanger: false }}
        />
      </>
  }

  return (
    <Card
      title={title}
      body={activeproblemsUI}
    />
  );
};